class FilterableVariants extends HTMLElement {
  constructor() {
    super();

    this.filter = this.querySelector("fv-filter-nz");
    this.variants = Array.from(this.querySelectorAll(".fv-variant"));
    this.grids = this.querySelectorAll("fv-grid-nz");

    this.addEventListener("filterOptionsChanged", ({ detail }) => {
      this.onOptionsChanged(detail.options);
      this.scrollIntoView({ behavior: "smooth" });
    });

    // FIX: Re-apply filters when page is restored from bfcache
    window.addEventListener('pageshow', (event) => {
      if (event.persisted && this.filter) {
        // Trigger filter update when page is loaded from cache
        this.filter.onOptionsChange();
      }
    });
  }

  onOptionsChanged(options) {
      const toCamelCase = (str) =>
        str
          .toLowerCase()
          .replace(/[^a-z0-9]+(.)/g, (_, char) => char.toUpperCase());
    
      const isFilterEmpty = Object.values(options).every((o) => o.length === 0);
    
      this.variants.forEach((variant) => {
        const shouldShow =
          isFilterEmpty ||
          Object.keys(options).every((key) => {
            const normalizedKey = toCamelCase(key);
            const variantValue = variant.dataset[normalizedKey];
            const optionValues = options[key];
    
            console.log(variantValue, optionValues, "hi");
    
            return optionValues.length === 0 ||
              (variantValue && optionValues.includes(variantValue));
          });
    
        variant.classList.toggle("hidden", !shouldShow);
      });
    
      this.grids.forEach((grid) => grid.onOptionsChanged(options));
    }
}
  
  class FilterableVariantsGrid extends HTMLElement {
    constructor() {
      super();
    }
  
    onOptionsChanged(options) {
      Object.keys(options).forEach((optionKey) => {
        if (options[optionKey].length > 1) {
          [...this.children]
            .sort(
              (a, b) =>
                options[optionKey].findIndex((o) => o === a.dataset[optionKey]) -
                options[optionKey].findIndex((o) => o === b.dataset[optionKey])
            )
            .forEach((node) => this.appendChild(node));
        }
      });
    }
  }
  
  class FilterableVariantsFilter extends HTMLElement {
    constructor() {
      super();
  
      this.options = Array.from(this.querySelectorAll("input[type=checkbox]"));
      this.clearButton = this.querySelector(".fv-filter__clear");
      this.viewAllButtons = document.querySelectorAll(".filterable-variants-nz__expand");
  
      // Dynamically initialize selectedOptions based on actual options in UI
      this.selectedOptions = this.getInitialOptionsState();
  
      this.clearButton.addEventListener("click", this.clear.bind(this));
      this.viewAllButtons.forEach((button) =>
        button.addEventListener("click", this.clear.bind(this))
      );
  
      this.options.forEach((option) =>
        option.addEventListener("change", this.toggleOption.bind(this))
      );
    }
  
    getInitialOptionsState() {
      const optionsState = {};
      this.options.forEach((option) => {
        const optionKey = option.name;
        if (!optionsState[optionKey]) {
          optionsState[optionKey] = [];
        }
      });
      return optionsState;
    }
  
    toggleOption(e) {
      const { name: option, value, checked } = e.target;
  
      if (checked) this.onSelectOption(option, value);
      else this.onDeselectOption(option, value);
  
      this.onOptionsChange();
    }
  
    onSelectOption(option, value) {
      if (!this.selectedOptions[option]) {
        this.selectedOptions[option] = [];
      }
      this.selectedOptions[option].unshift(value);
    }
  
    onDeselectOption(option, value) {
      this.selectedOptions[option] = this.selectedOptions[option].filter(
        (o) => o !== value
      );
    }
  
    onOptionsChange() {
      const hasActiveFilters = Object.values(this.selectedOptions).some((o) => o.length > 0);
  
      this.clearButton.disabled = !hasActiveFilters;
      this.viewAllButtons.forEach((b) => (b.disabled = !hasActiveFilters));
  
      this.dispatchEvent(
        new CustomEvent("filterOptionsChanged", {
          detail: { options: this.selectedOptions },
          bubbles: true,
        })
      );
    }
  
    clear() {
      this.options.forEach((option) => (option.checked = false));
      this.selectedOptions = this.getInitialOptionsState();
      this.onOptionsChange();
    }
  }
  
  // Register custom elements only if they are not already defined
  if (!customElements.get("fv-grid-nz")) customElements.define("fv-grid-nz", FilterableVariantsGrid);
  if (!customElements.get("filterable-variants-nz"))
    customElements.define("filterable-variants-nz", FilterableVariants);
  if (!customElements.get("fv-filter-nz")) customElements.define("fv-filter-nz", FilterableVariantsFilter);
  